import { Component } from '@angular/core';

@Component({
    selector: 'app-user-avatar',
    template: `
        <div class="btn-icon" id="nav-user-avatar">
            <i class="fa-solid fa-user"></i>
        </div>
    `,
    styles: [
        `
            #nav-user-avatar {
                width: 35px;
                height: 35px;
                border: 1px solid var(--greyBorderColor);
                background: white;

                i {
                    color: var(--appHightlightDarker);
                    font-size: 20px;
                }
            }
        `,
    ],
})
export class UserAvatarComponent {}
